import { paltaApi, FEATURES, makePaltaSubscriptionByPricePoint } from '@/modules/Palta'
import config from '@/config'

export default {
	namespaced: true,

	state: {
		subscriptions: []
	},

	getters: {
		getSubscriptionByFeature:
			(state) =>
			(feature = FEATURES.SIMPLE_PREMIUM) => {
				return state.subscriptions.find((subscription) => {
					return subscription.pricePoint.services.find(
						(service) => service.featureIdent == feature && subscription.cancelReason !== 'crossgrade'
					)
				})
			}
	},

	mutations: {
		store(state, subscriptions) {
			state.subscriptions = subscriptions
		}
	},

	actions: {
		async fetchSubscriptions(store, { user_id, ident }) {
			const { subscriptions = [], status } = await paltaApi.fetchSubscriptions(user_id)

			if (subscriptions.length) {
				store.commit('store', subscriptions)
			} else if (ident) {
				await store.dispatch('makeSubscriptionByIdent', { ident, user_id })
			}

			return {
				status,
				subscription: store.getters['getSubscriptionByFeature']()
			}
		},

		purchase(store, params) {
			return paltaApi.purchase(params)
		},

		async makeSubscriptionByIdent(store, { ident, user_id }) {
			const pricePoints = await paltaApi.fetchPricePoints(user_id, {
				ident: [ident]
			})

			const pricePoint = pricePoints?.find((pricePoint) => pricePoint.ident === ident)

			const paltaSubscription = makePaltaSubscriptionByPricePoint(pricePoint)

			store.commit('store', [paltaSubscription])
		},

		cancelSubscription(store, params) {
			return fetch(`${config('SimpleAPIUrl')}v1/api/subscription/paltabrain/cancel`, {
				method: 'POST',
				body: JSON.stringify(params)
			})
		}
	}
}
